// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wNDd","left":"styles_left__23XNR","desktopActions":"styles_desktopActions__dbAZh","title":"styles_title__36wbQ"};